import {
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage/plugin-tech-radar';
import techRadarData from './tech-radar-data.json';

export class TechRadarClient implements TechRadarApi {
  async load(): Promise<TechRadarLoaderResponse> {
    return {
      ...techRadarData,
      entries: techRadarData.entries.map(entry => ({
        ...entry,
        key: entry.id,
        timeline: entry.timeline.map(snapshot => ({
          ...snapshot,
          date: new Date(snapshot.date),
        })),
      })),
    };
  }
}
